import {numberFormat, parseTime} from "@/utils/index";

export class RegisterFilter {
  /**
   * @param Vue
   */
  constructor(Vue) {
    Vue.filter('numberFormat', function (value, decimals = 0) {
      return numberFormat(value, decimals)
    })

    Vue.filter('moneyFormat', function (value, decimals = 2) {
      return '￥' + numberFormat(value, decimals)
    })

    Vue.filter('numberFormatW', function (value, decimals = 2) {
      if (value >= 1e4) {
        const num = ((parseFloat(value) / 1e4)).toFixed(2)
        return numberFormat(num, decimals) + 'w'
      } else {
        return numberFormat(value)
      }
    })

    Vue.filter('parseTime', function (time, cFormat = '{y}/{m}/{d}') {
      return parseTime(time, cFormat)
    })

    Vue.filter('percentage', function (value, decimals = 0) {
      if (value > 100) {
        return 100
      }
      return numberFormat(value, decimals)
    })
  }
}
